import { VariantTreeDto } from "../VariantTreeDto";

export function getActiveVariant(
  variants: VariantTreeDto,
  selected: Record<string, string>,
) {
  const path = Object.entries(selected)
    .map(([key, value]) => `${key}=${value}`)
    .join("|");

  return variants.variants[path] ?? null;
}
